import { Switch, Route, Redirect } from 'react-router-dom'
import PlaygroundPage from './page/Playground'
import Layout from './playground/component/Layout'
import Adminpoly from './playground/Adminpoly'
import Button from './playground/Button'
import Carousel from './playground/Carousel'
import Checkbox from './playground/Checkbox'
import DataTable from './playground/DataTable'
import DatePicker from './playground/DatePicker'
import Dialog from './playground/Dialog'
import DialogFullScreen from './playground/DialogFullScreen'
import Dropdown from './playground/Dropdown'
import FormExample from './playground/FormExample'
import Loading from './playground/Loading'
import Map from './playground/Map'
import MenuDrawer from './playground/MenuDrawer'
import RadioGroup from './playground/RadioGroup'
import SlickCarousel from './playground/SlickCarousel'
import Slider from './playground/Slider'
import Snackbar from './playground/Snackbar'
import SwitchControl from './playground/Switch'
import TextEditor from './playground/TextEditor'
import Upload from './playground/Upload'
import ImageGallery from './playground/ImageGallery'
import AmChart from './playground/AmChart'
import DialogAlert from './playground/DialogAlert'

const MainPlayground = () => {
    return (
        <Layout>
            <Switch>
                <Route exact path="/playground/adminpoly">
                    <Adminpoly />
                </Route>
                <Route exact path="/playground/button">
                    <Button />
                </Route>
                <Route exact path="/playground/carousel">
                    <Carousel />
                </Route>
                <Route exact path="/playground/checkbox">
                    <Checkbox />
                </Route>
                <Route exact path="/playground/dataTable">
                    <DataTable />
                </Route>
                <Route exact path="/playground/datePicker">
                    <DatePicker />
                </Route>
                <Route exact path="/playground/dialog">
                    <Dialog />
                </Route>
                <Route exact path="/playground/dialogFullScreen">
                    <DialogFullScreen />
                </Route>
                <Route exact path="/playground/dropdown">
                    <Dropdown />
                </Route>
                <Route exact path="/playground/formExample">
                    <FormExample />
                </Route>
                <Route exact path="/playground/loading">
                    <Loading />
                </Route>
                <Route exact path="/playground/map">
                    <Map />
                </Route>
                <Route exact path="/playground/menuDrawer">
                    <MenuDrawer />
                </Route>
                <Route exact path="/playground/radioGroup">
                    <RadioGroup />
                </Route>
                <Route exact path="/playground/slickCarousel">
                    <SlickCarousel />
                </Route>
                <Route exact path="/playground/slider">
                    <Slider />
                </Route>
                <Route exact path="/playground/snackbar">
                    <Snackbar />
                </Route>
                <Route exact path="/playground/switch">
                    <SwitchControl />
                </Route>
                <Route exact path="/playground/textEditor">
                    <TextEditor />
                </Route>
                <Route exact path="/playground/upload">
                    <Upload />
                </Route>
                <Route exact path="/playground/ImageGallery">
                    <ImageGallery />
                </Route>
                <Route exact path="/playground/amChart">
                    <AmChart />
                </Route>
                <Route exact path="/playground/dialogAlert">
                    <DialogAlert />
                </Route>
                <Route exact path="/playground">
                    <PlaygroundPage />
                </Route>
                <Redirect to="/not-found" />
            </Switch>
        </Layout>
    )
}

export default MainPlayground
